(function($) {
    $(document).ready(function() {
        var $sections = $('.has-navigation-link'),
            $trigger = $('.onpage-nav--trigger__wrapper'),
            $triggerIcon = $('.onpage-nav--trigger'),
            $nav = $('#onpage-nav'),
            $navInner = $('#onpage-nav__inner');

        if ($nav.length) {
            for (var i = 0; i < $sections.length; i++) {
                var $section = $sections.eq(i),
                    $title = $.trim($section.find('.include-in-navigation').text()),
                    $id = $section.attr('id');
                $navInner.append('<a class="onpage-nav__link" href="#' + $id + '">' + $title + '</a>')
            }

            $trigger.on('click', function (e) {
                e.preventDefault();
                $trigger.toggleClass('closed');
                $trigger.toggleClass('manually-closed');
                $nav.toggleClass('closed');
                $nav.toggleClass('manually-closed');
            })

            // Progress bar functionality
            var bar = $('#progress-bar'),
                $window = $(window),
                docHeight = $(document).height(),
                baseX = $window.height() / docHeight * 100;

            bar.css('background', '-webkit-linear-gradient(left, black '+ baseX +'%, white '+ baseX +'%)');

            $window.scroll(function (e) {
                // Detect how far are we from the top of the page
                let windowTop = $(this).scrollTop();

                // Loop through every navigation menu item
                $('.onpage-nav__link').each(function (event) {

                    // Check for the current navigation item associated section
                    // Check how far the associated section is from the top
                    // If the associated section is as far as the user have scrolled, add 'active' class to the item.
                    if (windowTop >= $($(this).attr('href')).offset().top - 100) {

                        // Remove 'active' from previously highlighted menu items
                        $('.onpage-nav__link.active').removeClass('active');

                        // Highlight the current menu item by adding 'active' class
                        $(this).addClass('active');
                    }
                });

                var x = $window.scrollTop() / docHeight * 100 + baseX;
                bar.css('background', '-webkit-linear-gradient(left, black '+ x +'%, white '+ x +'%)');

                if ($(window).scrollTop() > 69){
                    if (!$nav.hasClass('manually-closed')) {
                        $nav.removeClass('closed');
                        $trigger.removeClass('closed');
                    }

                    $triggerIcon.addClass('visible');
                }
                else {
                    if (!$nav.hasClass('manually-closed')) {
                        $nav.addClass('closed');
                        $trigger.addClass('closed');
                    }

                    $triggerIcon.removeClass('visible');
                }
            });

            var $navItems = $('.onpage-nav__link')

            // Make the navigation draggable on desktop.
            $navInner.on('mousedown', function (event) {
                $(this)
                    .data('down', true)
                    .data('x', event.clientX)
                    .data('scrollLeft', this.scrollLeft);
                setTimeout(function() {
                    $navItems.addClass("prevent-click");
                }, 300);

                return false;
            }).on('mouseup', function (event) {
                $(this)
                    .data('down', false);
                setTimeout(function() {
                    $navItems.removeClass("prevent-click");
                }, 300);

            }).on('mousemove', function (event) {
                if ($(this).data('down') == true) {
                    this.scrollLeft = $(this).data('scrollLeft') + $(this).data('x') - event.clientX;
                }
            }).on('mouseleave', function (event) {
                $(this)
                    .data('down', false);
                setTimeout(function() {
                    $navItems.removeClass("prevent-click");
                }, 300);
            })
        }

        // Add smooth scrolling to onpage nav links
        $(".onpage-nav__link").on('click', function(event) {

            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "") {

                // Prevent default anchor click behavior
                event.preventDefault();

                // Store hash
                var hash = this.hash,
                    headerNavHeight = $('#onpage-nav').outerHeight();

                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('html, body').stop().animate({
                    scrollTop: $(hash).offset().top - headerNavHeight
                }, 800, 'swing');
            }
        });
    });
})(jQuery);
